import { orgJobsRoute } from '../../web-routes';

import { getTabName } from '../../util/navigation-tabs';

export const getPreviousLocation = (
  path: string,
  routeParams: {
    user?: AuthenticatedUser;
    orgId?: number;
  },
) => {
  const { user, orgId } = routeParams;
  let jobId: number | undefined;
  const jobPageUrlPrefix = `${orgJobsRoute(orgId)}/`;
  if (path.match(jobPageUrlPrefix)) {
    const parsedJobId = parseInt(path.replace(jobPageUrlPrefix, '').split('/')[0], 10);
    jobId = !Number.isNaN(parsedJobId) ? parsedJobId : undefined;
  }

  return getTabName(path, ['org', 'job'], { user, orgId, jobId });
};
